// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ArrowGo: React.FC = () => {
    return <svg width="37px" height="18px" viewBox="0 0 37 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-254.000000, -295.000000)" fill="currentColor">
            <polygon points="286.644282 302.714286 254 302.714286 254 305.285714 286.772392 305.285714 280.366925 311.328571 282.032346 313 291 304 282.032346 295 280.366925 296.671429"></polygon>
        </g>
    </g>
</svg>;
};

export default React.memo(ArrowGo);
